<t4-header icon="glyphicon-stats" title="{{'turbo.OneWay.Counting.Headline' |translate : 'Counting' }}">
  <button mat-button color="primary" (click)="openStartCountingMessageDialog()"><mat-icon>sports_kabaddi</mat-icon><span>{{ 'turbo.OneWay.Counting.cmdStartCounting' | translate:'Start counting'}}</span></button>
</t4-header>
<t4-container>
  <t4-data-table #tblCountings apiMethod="OneWay/GetCountings" headline="{{ 'turbo.OneWay.Counting.Headline' | translate : 'OneWay Countings' }}" matSort [autoGenerateColumns]="false"> 
    <ng-container matColumnDef="Details">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row"><a routerLink="/OneWay/Counting/{{row.Id}}" routerLinkActive="active">{{ 'turbo.OneWay.Counting.lnkDetails' | translate : 'Details' }}</a></mat-cell>
    </ng-container>
    <ng-container matColumnDef="StartDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.Counting.colStartDate' | translate : 'Start date' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.StartDate | date }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="EndDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.Counting.colEndDate' | translate : 'End date' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.EndDate | date }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Completion">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.Counting.colCompletion' | translate : 'Completion' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{row.Completion}}% ({{row.CompletedLocationCount}}/{{row.LocationCount}})</mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>
